import { Card } from '@ahafood/ui/components/card';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@ahafood/ui/components/dialog';
import { useNavigation } from '@/components/navigation/navigation-context';
import { useBottomPosition } from '@/hooks/use-bottom-position';
import { useIsMobile } from '@/lib/is-mobile';

type MaxDistanceDialogProps = {
  open: boolean;
  onClose: () => void;
};

export default function MaxDistanceDialog({
  open,
  onClose,
}: MaxDistanceDialogProps) {
  const isMobile = useIsMobile();
  const { isNavigationVisible } = useNavigation();
  const { bottomPosition } = useBottomPosition();
  return (
    <>
      {open ? (
        <>
          {isMobile ? (
            <div className="h-16 md:hidden">
              <div
                className="fixed inset-x-0 z-20 w-full max-w-lg mx-auto md:hidden"
                style={{ bottom: isNavigationVisible ? bottomPosition : 0 }}
              >
                <Card className="border-none !shadow-buttonDock rounded-none mx-px p-4">
                  <div className="w-full py-3 px-6 text-center font-bold text-red-50">
                    Địa chỉ của bạn nằm ngoài vùng giao hàng. Vui lòng chọn một
                    địa chỉ khác.
                  </div>
                </Card>
              </div>
            </div>
          ) : (
            <Dialog open={open} onOpenChange={onClose}>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle className="text-red-50">
                    Vùng giao hàng
                  </DialogTitle>
                </DialogHeader>
                <div className="py-4">
                  <p>
                    Địa chỉ của bạn nằm ngoài vùng giao hàng. Vui lòng chọn một
                    địa chỉ khác trong phạm vi{' '}
                    <span className="text-red-50 text-medium">20km</span>.
                  </p>
                </div>
              </DialogContent>
            </Dialog>
          )}
        </>
      ) : null}
    </>
  );
}
